<template>
  <v-container fluid>
    <v-card class="ui-module-card ui-module-fade-in-up cursos-programados-shell" flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="5" offset-lg="7">
            <v-text-field
              class="ui-form-field"
              v-model="buscaCurso"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              hide-details
              placeholder="Buscar capacitación por nombre..."
              aria-label="Buscar capacitación por nombre"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              class="cursos-table ui-module-table"
              :headers="headers"
              :items="filteredCursos"
              dark
              item-key="id"
              hide-default-footer
              disable-pagination
              dense
            >
              <template v-slot:[`item.subcategoria`]="{ item }">
                <span>{{ item.Subcategoria.subcategoria }}</span>
              </template>
              <template v-slot:[`item.categoria`]="{ item }">
                <span>{{ item.Subcategoria.CatCategoria.categoria }}</span>
              </template>
              <template v-slot:[`item.tipo`]="{ item }">
                <span>{{ item.Subcategoria.CatCategoria.CatTipoCurso.title }}</span>
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openEditModal(item)"
                      class="secondary--text mx-1 ui-module-icon-action"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar capacitación programada</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openDeleteModal(item)"
                      class="error--text mx-1 ui-module-icon-action"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar capacitación programada</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <div class="text-h6 justify-center" align="center">No hay capacitaciones programadas registradas</div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showDeleteDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h6"> Confirmar eliminación </v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar la capacitación programada
          <strong>{{ cursoToDelete?.Subcategoria?.subcategoria }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDeleteModal"> Cancelar </v-btn>
          <v-btn color="error" text @click="confirmDelete" :loading="isDeleting"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { DIALOG_TYPES } from '../../plugins/dialog-types'

export default {
  data() {
    return {
      buscaCurso: '',
      showDeleteDialog: false,
      cursoToDelete: null,
      isDeleting: false,
      headers: [
        { text: 'Capacitación', value: 'subcategoria' },
        { text: 'Categoría', value: 'categoria' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
    }
  },

  computed: {
    ...mapGetters('cursoProgramado', {
      cursosProgramados: 'getCursosProgramados',
    }),

    filteredCursos() {
      return this.cursosProgramados.filter((curso) => {
        return (
          curso.fkidEstatusCurso !== 4 &&
          curso.Subcategoria.subcategoria.toLowerCase().indexOf(this.buscaCurso.toLowerCase()) >= 0
        )
      })
    },
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('cursoProgramado', ['SET_SELECTED_CURSO_PROGRAMADO']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('cursoProgramado', ['updateCursoProgramado', 'fetchCursosProgramados']),

    openEditModal(cursoProgramado) {
      this.SET_SELECTED_CURSO_PROGRAMADO(cursoProgramado)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_CURSO_PROGRAMADO)
    },

    openDeleteModal(curso) {
      this.cursoToDelete = curso
      this.showDeleteDialog = true
    },

    closeDeleteModal() {
      this.showDeleteDialog = false
      this.cursoToDelete = null
    },

    async confirmDelete() {
      if (!this.cursoToDelete) return

      this.isDeleting = true
      try {
        const cursoActualizado = {
          ...this.cursoToDelete,
          fkidEstatusCurso: 4,
        }
        await this.updateCursoProgramado(cursoActualizado)
        await this.fetchCursosProgramados()
        this.closeDeleteModal()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al archivar la capacitación programada.')
      } finally {
        this.isDeleting = false
      }
    },
  },
}
</script>

<style scoped>
/* Input de búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(38, 222, 129, 0.75) !important;
}

/* Data Table */
::v-deep .cursos-table.v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
  border: 1px solid rgba(0, 210, 160, 0.15);
  overflow: hidden;
}

::v-deep .cursos-table > .v-data-table__wrapper {
  background: transparent !important;
}

::v-deep .cursos-table > .v-data-table__wrapper > table {
  background: transparent !important;
}

::v-deep .cursos-table > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}

::v-deep .cursos-table > .v-data-table__wrapper > table > thead {
  background: rgba(0, 210, 160, 0.15) !important;
}

::v-deep .cursos-table .v-data-table-header th {
  color: #26de81 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(0, 210, 160, 0.3) !important;
  padding: 16px !important;
  background: transparent !important;
}

::v-deep .cursos-table tbody tr {
  transition: all 0.3s ease;
  background: transparent !important;
}

::v-deep .cursos-table tbody tr:hover {
  background: rgba(0, 210, 160, 0.1) !important;
}

::v-deep .cursos-table tbody td {
  color: #e0e0e0 !important;
  background: transparent !important;
  border-bottom: 1px solid rgba(0, 210, 160, 0.1) !important;
  padding: 12px 16px !important;
}

::v-deep .cursos-table .v-data-table__empty-wrapper {
  background: transparent !important;
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .cursos-table .text-h6 {
  color: #e0e0e0 !important;
  font-weight: 600;
  padding: 32px 16px;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}

.cursos-programados-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .cursos-programados-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .cursos-programados-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
